import { Link } from "react-router-dom";
import { lineUrl } from "@/mocks/siteData";

export default function FloatingCTA() {
  return (
    <div className="fixed bottom-6 right-4 md:right-6 z-50 flex flex-col gap-3">
      <a
        href={lineUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-[#06C755] flex items-center justify-center text-white shadow-lg shadow-green-500/20 hover:scale-110 transition-transform duration-300"
        aria-label="加入 LINE 諮詢"
        title="加入 LINE 諮詢"
      >
        <i className="ri-line-fill text-xl md:text-2xl" />
      </a>
      <Link
        to="/booking"
        className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-gradient-to-br from-cyber-gold to-cyber-gold-dark flex items-center justify-center text-abyss-900 shadow-lg shadow-amber-500/20 hover:scale-110 transition-transform duration-300"
        aria-label="預約逆齡評估"
        title="預約逆齡評估"
      >
        <i className="ri-calendar-check-line text-xl md:text-2xl" />
      </Link>
    </div>
  );
}